import { Button, Col, Form, Row, message, Select, DatePicker } from "antd";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { reportService } from "_services";
import { FilterByAges } from "_helpers/enums";

function StocksAgingSearch(props) {
  const [form] = Form.useForm();
  let dateFilter = false;
  let fromDate = null;
  let toDate = null;

  // Set default value for stockClassId when stockClasses are loaded
  useEffect(() => {
    if (props.stockClasses && props.stockClasses.length > 0) {
      const finishedGoodStock = props.stockClasses.find(
        (stock) => stock.name === "FINISHED GOOD"
      );
      if (finishedGoodStock) {
        form.setFieldsValue({
          stockClassId: finishedGoodStock.id,
        });
      }
    }
  }, [props.stockClasses, form]);

  const onFinish = (values) => {
    props.showSearchLoading(true);
    let searchParams = "";
    searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";

    // if (values.requestDateRange) {
    //   searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
    //   searchParams += `fromDate=${encodeURIComponent(
    //     moment(values.requestDateRange[0]).startOf("day").format("YYYY-MM-DD")
    //   )}&toDate=${moment(values.requestDateRange[1])
    //     .startOf("day")
    //     .format("YYYY-MM-DD")}`;
    // }

    if (values.materialType) {
      searchParams += `&materialType=${values.materialType}`;
    }
    if (values.stockClassId) {
      searchParams += `&stockClassIdSearch=${values.stockClassId}`;
    }
    if (values.ageFilter) {
      searchParams += `&${values.ageFilter}=true`;
    }

    reportService
      .getStocksAging(searchParams)
      .then((data) => {
        props.onSearchResults(
          data.content[0].items || [],
          fromDate,
          toDate,
          dateFilter,
          searchParams
        );
        props.onSearchResultTotal(data.content[0] || []);
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([]);
      });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        {/* <Col span={4}>
          <Form.Item name="requestDateRange" label="Receive Date">
            <DatePicker.RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
            />
          </Form.Item>
        </Col> */}
        {/* <Col span={4}>
          <Form.Item name="storeLocationId" label="Store Location">
            <Select
              placeholder="Please select"
              allowClear
              loading={props.loadingStoreAddress}
            >
              {props.addresses.length > 0 &&
                props.addresses.map((t) => (
                  <Select.Option value={t.id} key={t.id}>
                    {t.address}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col> */}
        <Col span={4}>
          <Form.Item name="materialType" label="Material">
            <Select
              showSearch
              allowClear
              optionFilterProp="children"
              placeholder="Material Type"
              loading={props.loadingStockTypes}
            >
              {props.stockTypes.map((t) => (
                <Select.Option value={t.id} key={t.id}>
                  {t.code} - {t.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="stockClassId" label="Stock Category">
            <Select
              placeholder="Please select"
              allowClear
              loading={props.loadingStockClassification}
            >
              {props.stockClasses.length > 0 &&
                props.stockClasses.map((t) => (
                  <Select.Option value={t.id} key={t.id}>
                    {t.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="ageFilter" label="Age Filter">
            <Select placeholder="Please select" allowClear>
              {FilterByAges.map((age) => (
                <Select.Option value={age.value} key={age.value}>
                  {age.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}> </Col>
        <Col span={4}> </Col>
        <Col span={4} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onFinish({});
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default StocksAgingSearch;
